<template>
  <div
    class="face-filter-fixed-bottom"
    :style="{ opacity, pointerEvents: opacity > 0.4 ? 'auto' : 'none' }"
  >
    <v-layout row wrap>
      <v-flex xs12 offset-sm1 sm10 offset-md2 md8>
        <v-layout
          row
          align-center
          justify-space-between
          py-3
          px-2
          mx-3
          class="face-filter-content"
        >
          <v-layout
            row
            align-center
            justify-start
            class="face-filter-title"
            :style="{ opacity }"
          >
            <v-icon size="24px">face</v-icon>
            <div class="face-filter-text">顔認識フィルタ</div>
            <div class="new-feature-badge">新機能</div>
          </v-layout>
          <v-layout align-center justify-end :style="{ opacity }">
            <button
              class="toggle-button"
              :class="{ active: faceDetectedOnly }"
              @click.stop="toggleFaceDetectedOnly"
            >
              <div class="toggle-slider"></div>
            </button>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
const MAX_OPACITY = 1.0;

export default {
  props: {
    faceDetectedOnly: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      opacity: 0.0,
      // scrollTopがminとmaxの間の場合、徐々にopacityを変化させていく。
      minOpacityScrollTop: 0,
      // scrollTopがこの値以上なら背景opacityはMAX_OPACITY
      maxOpacityScrollTop: 400,
      minMaxScrollTopDiff: 0
    };
  },
  mounted() {
    this.minMaxScrollTopDiff =
      this.maxOpacityScrollTop - this.minOpacityScrollTop;

    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll({ target: document });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    toggleFaceDetectedOnly() {
      this.$emit("dismiss-face-filter-kid-tooltip");
      this.$emit("change-face-detected-only", !this.faceDetectedOnly);
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollingElement.scrollTop;
      let opacityRatio =
        (scrollTop - this.minOpacityScrollTop) / this.minMaxScrollTopDiff;
      this.opacity = MAX_OPACITY * Math.min(1.0, Math.max(0.0, opacityRatio));
    }
  }
};
</script>

<style scoped>
.face-filter-title {
  gap: 8px;
}

.face-filter-text {
  font-size: 16px;
}

.new-feature-badge {
  background-color: #dbe171;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1;
}

.face-filter-fixed-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3; /* フッターよりも上に表示する */
}

.face-filter-content {
  background-color: #ffffff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
}

/* ドロワーが表示される画面幅ではドロワー分だけ左をずらす (Drawer.vueのwidth=300, mobile-breakpoint=1264) */
@media (min-width: 1264px) {
  .face-filter-fixed-bottom {
    left: 300px;
  }
}

.toggle-button {
  background-color: #4cb5b8;
  border: none;
  border-radius: 31px;
  width: 56px;
  height: 32px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
}

.toggle-button:not(.active) {
  background-color: #ccc;
}

.toggle-slider {
  position: absolute;
  top: 5px;
  left: 5px;
  width: 22px;
  height: 22px;
  background-color: #ffffff;
  border-radius: 16px;
  transition: transform 0.3s ease;
}

.toggle-button.active .toggle-slider {
  transform: translateX(24px);
}

@media (max-width: 768px) {
  .face-filter-text {
    font-size: 14px;
  }

  .face-filter-content {
    margin-inline: 0 !important;
  }
}
</style>
